import { render, staticRenderFns } from "./new-schedule-covid19.vue?vue&type=template&id=68dc1c34&scoped=true&"
import script from "./new-schedule-covid19.vue?vue&type=script&lang=js&"
export * from "./new-schedule-covid19.vue?vue&type=script&lang=js&"
import style0 from "./new-schedule-covid19.vue?vue&type=style&index=0&id=68dc1c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dc1c34",
  null
  
)

export default component.exports